import Footer from "../components/Footer";
import HeaderBlog from "../components/HeaderBlog";
import ListaBlog from "../components/ListaBlog";
import Obs from "../components/Obs";
import TableBlog from "../components/TableBlog";
import TextoPadraoBlog from "../components/TextoPadraoBlog";
import TituloBlog from "../components/TituloBlog";


const NuncaDeclareiImposto = () => {
    return (
        <>
            <HeaderBlog
                titulo="Nunca declarei imposto de renda como autônomo. O que acontece agora?"
                subtitulo="Respira. Você não é o único. Mas também não é hora de continuar ignorando. A boa notícia: dá para resolver, e o caminho mais barato sempre é agir antes de ser chamado."
                data="20 de maio de 2025"
                tempoLeitura={6}
            />

            <TextoPadraoBlog
                texto={[
                    "A maioria das pessoas que nunca declarou não é desonesta. São pessoas que começaram a ganhar dinheiro por conta própria, acharam que o valor era pequeno, foram adiando, e de repente os anos passaram. Se esse é o seu caso, existe solução. E quanto antes você agir, menor o custo.",
                ]}
            /> 

            <TituloBlog index={1} titulo="Primeiro: você era obrigado a declarar?" />

            <TextoPadraoBlog
                texto={[
                    "Antes de entrar em pânico, é preciso entender se você realmente tinha obrigação de declarar. Nem todo autônomo é obrigado a declarar o IRPF, depende de quanto você recebeu. Para 2025, os principais critérios de obrigatoriedade são:",
                ]}
            />

            <TableBlog titulos={["Título", "Descrição"]} conteudo={[
                {
                    situacao: "Rendimentos tributáveis acima de R$ 33.888/ano",
                    valor: "Qualquer renda de trabalho autônomo, freelance, consultoria, aulas particulares ou prestação de serviço entra aqui. OBRIGADO A DECLARAR",
                },
                {
                    situacao: "Movimentação bancária acima de R$ 40.000/ano",
                    valor: "Mesmo que você ache que \"não teve lucro\", a movimentação bancária alta é critério independente de obrigatoriedade. OBRIGADO A DECLARAR",
                },
                {
                    situacao: "Bens acima de R$ 800.000",
                    valor: "Imóvel, veículo, investimentos, se o patrimônio total ultrapassa esse valor, a declaração é obrigatória independente da renda. VERIFICAR",
                },
                {
                    situacao: "Renda abaixo dos limites",
                    valor: "Se você recebeu abaixo dos limites em todos os anos, pode não ter tido obrigação. Mas confirme com um contador antes de concluir isso.",
                }]}
            />

            <Obs texto="Importante: os limites mudam a cada ano. A análise precisa ser feita exercício por exercício, não basta olhar só o ano atual. Um contador avalia cada período corretamente." />

            <TituloBlog index={2} titulo="O que acontece quando você não declara, a verdade sem drama" />

            <TextoPadraoBlog
                texto={[
                    "Existe muita desinformação sobre isso. A Receita Federal não manda a polícia na sua casa. O processo é gradual, mas é real, e vai crescendo com o tempo:",
                ]}
            />

            <ListaBlog itens={[
                <><b>Ano 1 a 2 sem declarar:</b> <br /> A Receita ainda está cruzando dados. Você pode não sentir nada, mas o relógio está correndo. A multa mínima por atraso já existe e cresce com o tempo. (Janela de ação, menor custo)</>,
                <><b>Inconsistência detectada:</b> <br /> A Receita cruza seus dados bancários, pagamentos de plataformas e notas emitidas. Quando identifica que você recebeu acima do limite sem declarar, seu CPF entra na fila de pendências. (CPF com restrição fiscal)</>,
                <><b>Notificação da Receita:</b> <br /> Você recebe uma intimação para regularizar ou apresentar documentos. A partir daqui, o processo é formal, e as multas e juros já estão acumulados sobre tudo que está atrasado. (Custo muito mais alto)</>,
                <><b>Lançamento de ofício:</b> <br /> Se você não responder nem regularizar, a Receita pode calcular o imposto que acha que você devia e cobrar com multa agravada de até 75%, mais juros SELIC sobre tudo. (Estágio mais caro)</>,
            ]} />

            <TituloBlog index={3} titulo="Quanto vai custar regularizar a situação" />

            <TextoPadraoBlog
                texto={[
                    "Essa é a parte que todo mundo quer saber. A resposta depende de quanto tempo faz que você deixou de declarar e qual era o imposto devido. Veja uma visão geral:",
                ]}
            />

            <TableBlog titulos={["Situação", "Multa mínima", "Juros", "Agravante"]} conteudo={[
                {
                    situacao: "Declaração em atraso, imposto já pago ou sem imposto devido",
                    valor: "R$ 165,74",
                    extraOne: "Nenhum",
                    extraTwo: "Nenhum"
                },
                {
                    situacao: "Declaração em atraso com imposto devido",
                    valor: "1% ao mês sobre o imposto (mín. R$ 165,74)",
                    extraOne: "SELIC acumulada",
                    extraTwo: "Nenhum"
                },
                {
                    situacao: "Notificado pela Receita antes de regularizar",
                    valor: "75% do imposto devido",
                    extraOne: "SELIC acumulada",
                    extraTwo: "Pode dobrar para 150%"
                },
                {
                    situacao: "Lançamento de ofício (sem resposta ao fisco)",
                    valor: "75% a 150% do imposto",
                    extraOne: "SELIC + 20% extra",
                    extraTwo: "Inscrição em dívida ativa"
                }]}
            />

            <Obs texto="Se você não tinha imposto a pagar (renda abaixo da faixa tributável mesmo sendo obrigado a declarar), a multa é apenas R$ 165,74 por declaração em atraso. Muita gente deve muito menos do que imagina." />

            <TituloBlog index={4} titulo="Passo a passo para regularizar a situação" />

            <TextoPadraoBlog
                texto={[
                    "Agora que você sabe o que está em jogo, veja o caminho prático para sair dessa situação:",
                ]}
            />


            <ListaBlog itens={[
                <>Junte extratos bancários, comprovantes de Pix recebidos, notas emitidas, recibos. O objetivo é reconstruir quanto você recebeu em cada exercício fiscal. Isso define se havia obrigação e quanto de imposto, se algum, era devido. <br /> <b>Conta o período dos últimos 5 anos, é o prazo de decadência fiscal</b></>,
                <>Nem todos os anos precisam de declaração retificadora. Se em algum exercício sua renda ficou abaixo dos limites, você pode não precisar declarar aquele período. Um contador faz essa análise rapidamente.<br /> <b>Não declare o que não precisa, isso evita multas desnecessárias</b> </>,
                <>O mesmo programa IRPF da Receita Federal aceita declarações de anos anteriores. Você preenche normalmente, indica o ano-base correto e entrega. A multa é calculada automaticamente. <br /> <b>Quanto mais rápido, menor o acúmulo de juros</b> </>,
                <>O DARF gerado pode ser pago via banco ou aplicativo. Se o valor for alto, o parcelamento junto à Receita Federal é uma opção, com juros SELIC, mas sem agravamento da situação. <br /> <b>Parcelamento em até 60 meses no Refis vigente</b> </>,
                <>Regularizar o passado é metade do trabalho. A outra metade é não voltar para a mesma situação. Esse é o momento certo para estruturar seu negócio, CNPJ, regime tributário, emissão de notas, e nunca mais ter esse problema.  <br /> <b>A ContBlack cuida de tudo isso por você</b></>,
            ]} />

            <TituloBlog index={5} titulo="O programa de autorregularização da Receita Federal" />

            <Obs texto="O programa de autorregularização permite que contribuintes que identificam inconsistências em suas declarações, ou que nunca declararam, se regularizem antes de serem formalmente notificados. Os benefícios são reais: multas menores, parcelamento facilitado e encerramento do processo sem autuação. Quem espera ser chamado perde acesso a essas condições." />

            <TituloBlog index={6} titulo="Por que regularizar agora muda tudo na sua vida financeira" />

            <TextoPadraoBlog
                texto={[
                    "Muita gente adia a regularização achando que só perde dinheiro com isso. Na prática, é o contrário. Veja o que se abre quando o CPF está limpo:",
                ]}
            />

            <ListaBlog itens={[
                <><b>Financiamento imobiliário:</b> <br /> Bancos exigem declaração dos últimos 2 anos para aprovar crédito. Sem declaração, sem financiamento.</>,
                <><b>Crédito e consórcio:</b> <br /> Pendência fiscal aparece na análise de crédito. CPF regularizado abre linhas que CPF sujo fecha.</>,
                <><b>Visto americano e europeu:</b> <br /> Consulados pedem comprovante de renda e declaração do IR. Irregular, você pode ter o visto negado.</>,
                <><b>Contratos maiores:</b> <br /> Empresas que pagam acima de R$ 5 mil por serviço retêm imposto e precisam de prestador regularizado.</>,
                <><b>Paz mental:</b> <br /> Não tem preço. Deixar de acordar todo ano pensando "será que esse é o ano em que me pegam" vale cada centavo da regularização.</>,
                <><b>Abrir empresa:</b> <br /> Com o CPF regularizado, você pode abrir um CNPJ e estruturar o negócio para pagar menos imposto legalmente daqui em diante.</>,
            ]} />

            <Obs texto="Não importa quanto tempo você ficou longe. O importante é voltar antes de ser chamado." />

            <Footer />
        </>
    );
}

export default NuncaDeclareiImposto;